import RLXStore from 'RLX/State/Store';

import {
  sidebarPagesListExpanded,
  sidebarPagesListCollapsed,
  sidebarBlogsListExpanded,
  sidebarBlogsListCollapsed,
  sidebarAssetsListExpanded,
  sidebarAssetsListCollapsed
} from 'RLX/State/Ui/Sidebar/SidebarCreators';

export function expandSidebarBlogsList () {
  RLXStore.dispatch(sidebarBlogsListExpanded());
}
export function collapseSidebarBlogsList () {
  RLXStore.dispatch(sidebarBlogsListCollapsed());
}

export function expandSidebarPagesList () {
  RLXStore.dispatch(sidebarPagesListExpanded());
}
export function collapseSidebarPagesList () {
  RLXStore.dispatch(sidebarPagesListCollapsed());
}

export function expandSidebarAssetsList () {
  RLXStore.dispatch(sidebarAssetsListExpanded());
}
export function collapseSidebarAssetsList () {
  RLXStore.dispatch(sidebarAssetsListCollapsed());
}



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/Sidebar/SidebarActions.js